import { Flex } from "@mantine/core"

const MantineFlex = (props: any) => {
    const { children, gap, justify, align, direction, wrap, className, key, onClick} = props
    return (
        <Flex
            gap={gap}
            justify={justify}
            align={align}
            direction={direction}
            wrap={wrap}
            key={key}
            onClick={onClick}
            className={className}
        >
            {children}
        </Flex>)
}
export default MantineFlex